import type { PublicEvent, MovieOption } from '../../shared/protocol';

/** Live vote tally with poster thumbnails and animated bars. Results aren't voting, so a
 * thumbnail click (when onPosterClick is given) opens the enlarged poster. */
export function TallyBoard({
  event,
  onPosterClick,
}: {
  event: PublicEvent;
  onPosterClick?: (o: MovieOption) => void;
}) {
  const max = Math.max(1, ...event.options.map((o) => event.tally[o.id] ?? 0));
  const leader = event.totalVotes > 0 ? max : 0;

  return (
    <div className="tally">
      {event.options.map((o) => {
        const count = event.tally[o.id] ?? 0;
        const pct = Math.round((count / max) * 100);
        const isWinner = count > 0 && count === leader;
        const zoomable = Boolean(onPosterClick && o.posterUrl);
        return (
          <div key={o.id} className={`tally-row${isWinner ? ' winner' : ''}`}>
            <div
              className="thumb"
              style={{
                ...(o.posterUrl ? { backgroundImage: `url(${o.posterUrl})` } : {}),
                cursor: zoomable ? 'zoom-in' : undefined,
              }}
              onClick={zoomable ? () => onPosterClick!(o) : undefined}
              role={zoomable ? 'button' : undefined}
              title={zoomable ? 'View poster' : undefined}
            />
            <div className="tally-bar-wrap">
              <div className="tally-label">
                <span>
                  {isWinner && '👑 '}
                  {o.title}
                  {o.year ? ` (${o.year})` : ''}
                </span>
                <span className="count">{count}</span>
              </div>
              <div className="tally-bar-track">
                <div className="tally-bar-fill" style={{ width: `${Math.max(pct, count > 0 ? 8 : 0)}%` }} />
              </div>
            </div>
          </div>
        );
      })}
      <div className="soft center" style={{ marginTop: 4 }}>
        {event.totalVotes === 0
          ? 'No votes yet — be the first!'
          : `${event.totalVotes} vote${event.totalVotes === 1 ? '' : 's'} so far`}
      </div>
    </div>
  );
}
